import { aMatchRule } from '__generated__';

export const SAMPLE_RULES = [
  aMatchRule({
    enabled: true,
    id: 'MATCH-S00307',
    name: 'AWS - Excessive OAuth Application Permissions Scope',
  }),
  aMatchRule({
    enabled: true,
    id: 'MATCH-S00458',
    name: 'ADPassHunt Tool',
  }),
];
